import { render } from "./setpin.vue?vue&type=template&id=2104e81e&scoped=true"
import script from "./setpin.vue?vue&type=script&lang=js"
export * from "./setpin.vue?vue&type=script&lang=js"

import "./setpin.vue?vue&type=style&index=0&id=2104e81e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2104e81e"]])

export default __exports__